import { ThemeColors } from '../../utils/theme/colors.theme'

interface ThumbnailProps {
  url?: string
  alt: string
  size?: string
  padding?: string
  rounded?: boolean
}

const Thumbnail = ({ url, alt, size = '100px', padding = '10px', rounded }: ThumbnailProps) => {
  if (url) {
    return (
      <div style={{ height: size, padding, width: size }}>
        <img
          src={url}
          alt={alt}
          style={{
            borderRadius: rounded ? 30 : undefined,
            height: '100%',
            objectFit: 'cover',
            width: '100%',
          }}
        />
      </div>
    )
  }

  // Return grey div
  return (
    <div style={{ height: size, padding, width: size }}>
      <div
        style={{
          backgroundColor: ThemeColors.GREY_20,
          borderRadius: rounded ? 30 : undefined,
          height: '100%',
          width: '100%',
        }}
      />
    </div>
  )
}

export default Thumbnail
